(() => {
    const pageType = document.body?.dataset?.pageType;

    const run = () => {
        let productCard = document.getElementsByClassName('product-card');

        if(pageType === 'cart') {
            setTimeout(() => {
                getVariant(productCard);
            }, 2500);
        } else {
            getVariant(productCard);
        }
    };

    const delayMs = pageType === 'product' ? 1500 : 300;

    if(document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => setTimeout(run, delayMs));
    } else {
        setTimeout(run, delayMs);
    }

    // Enchliving: los clones de Splide repiten los id de los radios. Resolver el
    // input desde la card pulsada evita que el label active una instancia distinta.
    document.addEventListener('click', (event) => {
        const label = event.target.closest('.product-card__swatch-list label.color-swatch, .product-card__variant-list label.thumbnail-swatch');
        if (!label) return;

        const input = label.previousElementSibling;
        if (!input?.classList.contains('sr-only-variant') || input.disabled) return;

        event.preventDefault();
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Enchliving: Featured Collection muestra la imagen secundaria. Al cambiar
    // la variante se actualizan esa capa visible y las instancias clonadas.
    document.addEventListener('change', (event) => {
        const changedInput = event.target;
        if (!changedInput.classList.contains('sr-only-variant') || !changedInput.dataset.variantMedia) return;

        const product = changedInput.closest('product-card');
        if (!product) return;

        const variantId = changedInput.dataset.variantId;
        const handle = product.getAttribute('handle');
        const primaryMedia = parseMedia(changedInput.dataset.variantMedia);
        const secondaryMedia = parseMedia(changedInput.dataset.variantSecondaryMedia) || primaryMedia;
        const instances = handle
            ? document.querySelectorAll(`product-card[handle="${handle}"]`)
            : [product];

        instances.forEach((instance) => {
            instance.querySelectorAll('.sr-only-variant').forEach((input) => {
                const selected = input.dataset.variantId === variantId;

                if (instance === product) input.checked = selected;

                const label = input.nextElementSibling;
                if (label?.matches('label.color-swatch, label.thumbnail-swatch')) {
                    label.classList.toggle('is-selected', selected);
                }
            });

            if (handle && variantId) {
                instance.querySelectorAll('a').forEach((link) => {
                    try {
                        const url = new URL(link.href);
                        if (url.pathname.includes(`/products/${handle}`)) {
                            url.searchParams.set('variant', variantId);
                            link.href = `${url.pathname}${url.search}${url.hash}`;
                        }
                    } catch(e) {}
                });
            }

            updateCardImage(instance, '.product-card__image--primary', primaryMedia);
            updateCardImage(instance, '.product-card__image--secondary', secondaryMedia);
        });
    });

    function parseMedia(value) {
        if (!value) return null;

        try {
            return JSON.parse(value);
        } catch(e) {
            return null;
        }
    }

    function updateCardImage(product, selector, media) {
        const image = product.querySelector(selector);
        const preview = media?.preview_image;
        if (!image || !preview?.src) return;

        const widths = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];
        const maxWidth = Number(preview.width) || widths[widths.length - 1];

        image.src = preview.src;
        image.srcset = widths
            .filter((width) => width <= maxWidth)
            .map((width) => `${shopifyImageUrl(preview.src, width)} ${width}w`)
            .join(', ');
        image.alt = media.alt || '';
    }

    function shopifyImageUrl(src, width) {
        try {
            const normalizedSrc = src.startsWith('//') ? `https:${src}` : src;
            const url = new URL(normalizedSrc, window.location.origin);
            url.searchParams.set('width', width);
            return url.toString();
        } catch(e) {
            return src;
        }
    }

    function getVariant(productCard) {
        for(let i = 0; i < productCard.length; i++) {
            let product = productCard[i];

            // Enchliving: detectar si es un slide clonado de Splide
            const isClone = !!product.closest('.splide__slide--clone');

            let productCardImageContainer = product.getElementsByClassName('product-card__figure')[0];
            if (!productCardImageContainer) continue;

            let imageLink = productCardImageContainer.getElementsByClassName('link-image')[0];

            if (imageLink) {
                let imageLinkHref = imageLink.getAttribute('href');
                let mainMediaIdInput = product.querySelector('.productMainMediaId');
                let mainMediaId = mainMediaIdInput ? mainMediaIdInput.value.trim() : null;
                let productVariantscontainer = product.getElementsByClassName('product-card__aside')[0];

                // Solo hacer matching inicial (checked = true) en cards originales,
                // no en clones, para evitar el error de aria-hidden
                if (!isClone && productVariantscontainer && mainMediaId) {
                    let actualVariant = product.getElementsByClassName('sr-only-variant');

                    for (let x = 0; x < actualVariant.length; x++) {
                        if (actualVariant[x].dataset.variantMedia) {
                            let dataMedia = actualVariant[x].dataset.variantMedia;
                            let dataMediaJson = JSON.parse(dataMedia);

                            if (String(dataMediaJson.id) === mainMediaId) {
                                let variantID = actualVariant[x].dataset.variantId;
                                imageLink.href = `${imageLinkHref}?variant=${variantID}`;
                                actualVariant[x].checked = true;
                                const inputId = actualVariant[x].id;

                                if (inputId) {
                                    const swatchLabel = product.querySelector(`label.color-swatch[for="${inputId}"]`);
                                    if (swatchLabel && actualVariant[x].checked) {
                                        swatchLabel.classList.add('is-selected');
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    };
})()
